<template>
  <b-card no-body class="card-map-tij overflow-hidden h-100" >
    <b-row no-gutters class="h-100">
      <b-col md="6">
        <b-card-body title="Patio San Diego">
          <b-card-text>
            9010 Paseo de la Fuente Norte
            <br>San Diego, California, EEUU
            <br>
            <br>
            <br>
            <br>
          </b-card-text>
        </b-card-body>
      </b-col>
      <b-col md="6" class="d-flex justify-content-center">
        <div class="mapouter">
          <div class="gmap_canvas">
            <iframe width="100%" height="100%" id="gmap_canvas" src="https://maps.google.com/maps?width=100%25&amp;height=600&amp;hl=en&amp;q=9010%20Paseo%20de%20la%20Fuente%20Norte+()&amp;t=&amp;z=14&amp;ie=UTF8&amp;iwloc=B&amp;output=embed" frameborder="0" scrolling="no" marginheight="0" marginwidth="0">
            </iframe>
          </div>
        </div>
      </b-col>
    </b-row>
  </b-card>
</template>

<script>
export default {
  name: 'MapCardSanDiego'
}
</script>

<style>
.card{
  margin: 0 0;
}
.mapouter{position:relative;text-align:right;height:100%;width:100%;}
.gmap_canvas {overflow:hidden;background:none!important;height:100%;width:100%;}
</style>
